import React, { useState } from 'react'
import { useNavigation } from '@react-navigation/native'
import { TokenType } from '@vatom/sdk/core'
import { useAnalytics } from '@vatom/sdk/react'
import { translate } from '@vatom/utils'
import { GradientButton, Status, Text, Toast } from '@vatom/wombo'
import { Actionsheet, Box, Divider, VStack } from 'native-base'

import Alert from '../../../components/Alert'
import { useMaxWidth } from '../../../components/WebWrapper'
import { useBusinessSelector, withBusinessSelector } from '../../../hooks/useBusinessSelector'
import logger from '../../../logger'
import { AppRoutes, TabRoutes } from '../../../navigators'
import ProcessButton from '../partials/ProcessButton'

interface ActionSheetDeleteProps {
  setOpen: (b: boolean) => void
  isOpen: boolean
  token: TokenType
}

const ActionSheetDeleteBase = ({ isOpen, setOpen, token }: ActionSheetDeleteProps) => {
  logger.info('ActionSheetDelete')
  const navigation = useNavigation()
  const analytics = useAnalytics()
  // const [isDeleteSuccess, setIsDeleteSuccess] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const maxWidth = useMaxWidth()
  const { business } = useBusinessSelector()

  const goBack = () => {
    if (business?.id) {
      navigation.navigate(AppRoutes.BusinessProxy, {
        business: business?.id,
        screen: TabRoutes.Wallet
      })
      return
    } else {
      navigation.navigate(AppRoutes.home, {
        screen: 'Wallet'
      })
      return
    }
  }

  if (!isOpen) {
    return null
  }

  const deleteAction = async () => {
    if (!token) return

    setIsLoading(true)
    // Navigate await from token before deleting it

    try {
      await token.performAction('Delete')
      await analytics.event('performAction', {}, token)
      Toast({
        title: translate('deleteNft.success'),
        placement: 'top',
        status: Status.success
      })
    } catch (error) {
      Alert.showError(error)
    } finally {
      setIsLoading(false)
      setOpen(false)
      goBack()
    }
  }

  return (
    <Actionsheet
      isOpen={isOpen}
      onClose={() => setOpen(false)}
      maxWidth={maxWidth}
      margin={'auto'}
      useRNModal={true}
      // @ts-ignore prop doesn't exit on types
      _backdropFade={{
        entryDelay: 150,
        exitDelay: 10
      }}
    >
      {/* {isDeleteSuccess ? (
        <Success onSuccess={onSuccess} />
      ) : ( */}
      <Actionsheet.Content pt="20px" pb="16px" px={0}>
        <VStack w="100%" paddingX="16px">
          <Text textAlign="center" tx="deleteNft.shouldDelete" />
        </VStack>

        <Divider backgroundColor="gray.900" height="0px" mt={4} />
        <Box width={'100%'} px={4}>
          <ProcessButton
            label={translate('common.delete')}
            isDisabled={isLoading}
            onPress={deleteAction}
            isLoading={isLoading}
          />
        </Box>

        <Divider backgroundColor="gray.900" height="0px" mt={4} />

        <Box width={'100%'} px={4}>
          <GradientButton
            colorScheme="gray"
            w="100%"
            justifyContent="center"
            onPress={() => setOpen(false)}
            disabled={isLoading}
          >
            <Text
              color="white"
              fontFamily="Inter-SemiBold"
              alignSelf="center"
              py={2}
              fontSize="18px"
              tx="common.cancel"
            />
          </GradientButton>
        </Box>
      </Actionsheet.Content>
      {/* )} */}
    </Actionsheet>
  )
}

export const ActionSheetDelete = withBusinessSelector(ActionSheetDeleteBase)
export default ActionSheetDelete
